import { useCallback } from "react";
import useAjax from "@apis/useAjax";
import { 
    GET_CAMPAIGN_OVERVIEW_OPTIONS_API, 
    POST_CAMPAIGN_OVERVIEW_API 
} from "@apis/apiPath";

const useCampaignApi = () => {
	const Ajax = useAjax();

	// 取得抵用券訂單的下拉式選單
	const getCampaignOverviewOptionsApi = useCallback(
		async () => {
			return await Ajax.get(GET_CAMPAIGN_OVERVIEW_OPTIONS_API);
		},
		// eslint-disable-next-line
		[]
	);

	// 取得抵用券訂單列表
	const postCampaignOverviewApi = useCallback(
		async params => await Ajax.post(POST_CAMPAIGN_OVERVIEW_API, params),
		// eslint-disable-next-line
		[]
	);

	return {
		getCampaignOverviewOptionsApi,
		postCampaignOverviewApi,
	};
};

export default useCampaignApi;
